module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-01-m-en.3c8126c2945abb838baf934919da639d.png";